import type {PluginComponent} from 'types/store/plugins';

const REMINDER_PLUGIN_ID = 'ru.tinkoff.time.reminder-plugin';
export const isReminderPlugin = ({pluginId}: PluginComponent) => pluginId === REMINDER_PLUGIN_ID;
